import { createContext, FC, PropsWithChildren, useState } from "react";
import {
  DoctorLicenseTpe,
  DoctorMasterDataContextType,
  TimeSlotType,
} from "../types";
export const DoctorMasterDataContext =
  createContext<DoctorMasterDataContextType>({
    licenseList: [],
    setLicenseList: () => {},
    timeSlots:{},
    setTimeSlots:() => {},
    isTimeEdit:false,
    setIsTimeEdit:()=>{}
  });

const DoctorMasterDataProvider: FC<PropsWithChildren> = ({ children }) => {
  const [licenseList, setLicenseList] = useState<DoctorLicenseTpe[]>([]);
  const [timeSlots, setTimeSlots] = useState<{[key:number]:TimeSlotType}>({});
  const [isTimeEdit,setIsTimeEdit] = useState<boolean>(false)
  return (
    <DoctorMasterDataContext.Provider
      value={{ licenseList, setLicenseList, timeSlots, setTimeSlots,isTimeEdit,setIsTimeEdit }}
    >
      {children}
    </DoctorMasterDataContext.Provider>
  );
};

export default DoctorMasterDataProvider;
